import { render, staticRenderFns } from "./verificationList.vue?vue&type=template&id=efd8cd52&scoped=true&"
import script from "./verificationList.vue?vue&type=script&lang=js&"
export * from "./verificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd8cd52",
  null
  
)

export default component.exports